import styles from "./card.module.css"
export function Card(props){
    return(
        <div className={styles.Card}>
            {props.children}
        </div>
    )
}